import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { RefreshHistoryItemsHandler } from "./handler";
import { HandleRefreshHistoryItems } from "./request";

let request: BrokerDisposableHandler;

export const bootstrapHandleRefreshHistoryItems = (broker: BrokerExtensions) => {
  teardownHandleRefreshHistoryItems();
  request = broker.registerRequest(HandleRefreshHistoryItems, RefreshHistoryItemsHandler);
};

export const teardownHandleRefreshHistoryItems = () => {
  request?.dispose();
};
